import axios from 'axios';
import router from '@/router';
// import { wait } from '@/utils';

export default {
  namespaced: true,
  state: {
    firstName: localStorage.getItem('firstName') || null,
    initials: localStorage.getItem('initials') || null,
    token: localStorage.getItem('token') || null,
    userId: localStorage.getItem('userId') || null,
    role: localStorage.getItem('role') || false,
    error: null,
    loading: false
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setFirstName(state, firstName) {
      state.firstName = firstName;
    },
    setInitials(state, initials) {
      state.initials = initials;
    },
    clearAuthToken(state) {
      state.token = null;
    }
  },
  actions: {
    setLogoutTimer({ commit, dispatch }, expirationTime) {
      setTimeout(() => {
        commit('clearAuthToken');
        dispatch('logout');
      }, expirationTime * 1000);
    },
    async login({ state, commit }, credentials) {
      try {
        state.loading = true;
        const { data } = await axios.post('/auth/login', credentials);
        const { token } = data;
        const expirationDate = data.expire;

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        localStorage.setItem('token', token);
        localStorage.setItem('expirationDate', expirationDate);

        const { data: info } = await axios.post('/auth/init', credentials);
        state.firstName = info.firstName;
        localStorage.setItem('firstName', info.firstName);
        state.initials = info.initials;
        localStorage.setItem('initials', info.initials);
        state.role = info.role;
        localStorage.setItem('role', info.role);
        commit('setToken', token);
        router.push({ name: 'Root' }).catch(ex => ex);
      } catch (ex) {
        router.push('/login').catch(ex => ex);
      } finally {
        state.loading = false;
      }
    },
    async logout({ commit }) {
      commit('clearAuthToken');
      commit('dock/clearState', null, { root: true });
      commit('user/clearState', null, { root: true });
      localStorage.removeItem('token');
      localStorage.removeItem('expirationDate');
      localStorage.removeItem('firstName');
      localStorage.removeItem('initials');
      localStorage.removeItem('role');
      router.replace('/login').catch(ex => ex);
    }
  },
  getters: {
    token: state => state.token || localStorage.getItem('token'),
    isAuthenticated: state => !!state.token && !!state.firstName,
    isAdmin: state => state.role === 'admin',
    isSupervisor: state => state.role === 'supervisor',
    isUser: state => state.role === 'user' || state.role === '',
    firstName: state => state.firstName || localStorage.getItem('firstName') || null,
    userId: state => state.userId || localStorage.getItem('userId') || null,
    initials: state => state.initials || localStorage.getItem('initials') || null
  }
};
